// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H1uc","top":"styles_top___ITWa","left":"styles_left__1LAb7","description":"styles_description__3p2eC"};